import { createSelector } from '@ngrx/store';
import { memberSignupPolicyState } from '../root';

export const getPasswordPolicy = createSelector(memberSignupPolicyState, (memberSignupPolicy) => memberSignupPolicy?.data?.PasswordPolicy);
